import React, { useEffect, useState } from 'react';
import { Route } from 'react-router-dom';
import { DataIndicators } from '../../components/DataIndicators';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { SiteProfilePage } from '../../components/SiteProfile/SiteProfilePage';
import { useSiteProfileData } from '../../data/DataProviders/SiteProfileDataProvider';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { AppRoutes } from '../../routes';
import { isDataLoaded, SiteProfile } from '../../types';
import { EditSiteProfile } from './EditSiteProfile';

export const SiteProfileContainer: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const { t } = useLanguageLocale();
    const currentAppRoute = useCurrentAppRoute()
    const siteProfileData = useSiteProfileData();
    const [modifiedData, setModifiedData] = useState<SiteProfile | null>(null);
    const [siteData, setSiteData] = useState<SiteProfile | null>(null);
    const updatedSiteData = (value: SiteProfile): void => {
        setModifiedData(value);
    }
    useEffect(() => {
        if (isDataLoaded(siteProfileData)) {
            setSiteData(siteProfileData.value);
        }
    }, [siteProfileData])
    
    useEffect(() => {
        if (isDataLoaded(siteProfileData) && modifiedData) {
            const data = { ...siteProfileData.value };
            data.name = modifiedData.name;
            data.longitude = modifiedData.longitude;
            data.latitude = modifiedData.latitude;
            data.description = modifiedData.description;
            setSiteData(data);
        }
    }, [modifiedData]) //eslint-disable-line react-hooks/exhaustive-deps
    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />
            <DataIndicators
                errorMessage="No Site Data"
                emptyMessage="No Site Data"
                data={siteProfileData}
                emptyIcon="LocationOn"
                isEmpty={false}
            />

            <Route exact path={AppRoutes.SiteProfile} >
                {isRecordFound(selectedOrganization) && 'locationId' in currentAppRoute && siteData &&
                    <SiteProfilePage testId="site-profile" data={siteData}
                    appRoute={{ type: 'LocationProfile', orgId: selectedOrganization.value.id, locationId: currentAppRoute.locationId }} />
                }
            </Route>
            <Route exact path={AppRoutes.EditSite} >
                <EditSiteProfile updatedSiteData={updatedSiteData} data={siteData}/>
            </Route>

        </>
    )
}
